var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedfarMedfarLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.196 12.975h6.73c-.075.75-.15 1.425-.375 2.175H16.3l-1.944-6.9h-2.617l-2.018 6.3-2.094-6.3H4.935l-1.795 6.9-.299 1.5h1.87l1.794-6.9 2.243 6.225c.15.45.523.675.972.675.448 0 .897-.3 1.046-.75l2.094-6.225 1.645 6c.15.6.673.975 1.27.975h7.253C21.234 20.925 16.972 24 11.963 24 5.383 24 0 18.6 0 12S5.383 0 11.963 0a11.98 11.98 0 0111.364 8.175H15.85l.45 1.5h7.476c.15.675.224 1.275.224 1.95h-7.103l.3 1.35z"
  })));
}
export default SvgMedfarMedfarLogo;